export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/instagram-icon.be4448d4.svg","height":19,"width":18};